import { breakpoint } from '../config/breakpoint';

/**
 * @name small
 */

export const sm = (content) => `
    @media (max-width: ${breakpoint.sm}) {
        ${content}
      }
    `;

/**
 * @name medium
 */

export const md = (content) => `
    @media (max-width: ${breakpoint.md}) {
        ${content}
      }
    `;

/**
 * @name large
 */

export const lg = (content) => `
    @media (max-width: ${breakpoint.lg}) {
        ${content}
      }
    `;

/**
 * @name xl
 */

export const xl = (content) => `
    @media (max-width: ${breakpoint.xl}) {
        ${content}
      }
    `;

/**
 * @name custom
 */

export const custom = (size, content) => `
    @media (max-width: ${size}) {
        ${content}
      }
    `;
